module.exports = __webpack_public_path__ + "img/icon-pdf-document.d3f57c6b.svg";